import { Injectable } from '@angular/core';
import { VKratosUiWidget } from './types';

@Injectable()
export class WebAuthNService {
  public async webauthnRegistration(node: VKratosUiWidget) {
    const onClickAttr = (node.attributes as any).onclick;

    const startIndex = onClickAttr.indexOf('{');
    const endIndex = onClickAttr.lastIndexOf('}');
    const fidoConfig = JSON.parse(
      onClickAttr.substring(startIndex, endIndex + 1)
    );

    fidoConfig.publicKey.challenge = this.__oryWebAuthnBufferDecode(
      fidoConfig.publicKey.challenge
    );
    fidoConfig.publicKey.user.id = this.__oryWebAuthnBufferDecode(
      fidoConfig.publicKey.user.id
    );

    const res = await navigator.credentials.create(fidoConfig);

    if (!res || res.type !== 'public-key') {
      throw Error('failed to create public key');
    }

    const credentials = res as PublicKeyCredential;
    const attestationObject =
      credentials.response as AuthenticatorAttestationResponse;

    const result = {
      id: credentials.id,
      rawId: this.__oryWebAuthnBufferEncode(credentials.rawId),
      type: credentials.type,
      response: {
        attestationObject: this.__oryWebAuthnBufferEncode(
          attestationObject.attestationObject
        ),
        clientDataJSON: this.__oryWebAuthnBufferEncode(
          credentials.response.clientDataJSON
        ),
      },
    };

    return result;
  }

  public async webauthnLogin(node: VKratosUiWidget) {
    const onClickAttr = (node.attributes as any).onclick;

    const startIndex = onClickAttr.indexOf('{');
    const endIndex = onClickAttr.lastIndexOf('}');
    const fidoConfig = JSON.parse(
      onClickAttr.substring(startIndex, endIndex + 1)
    );

    fidoConfig.publicKey.challenge = this.__oryWebAuthnBufferDecode(
      fidoConfig.publicKey.challenge
    );

    fidoConfig.publicKey.allowCredentials =
      fidoConfig.publicKey.allowCredentials.map((value: any) => {
        return {
          ...value,
          id: this.__oryWebAuthnBufferDecode(value.id),
        };
      });

    const res = await navigator.credentials.get(fidoConfig);

    if (!res || res.type !== 'public-key') {
      throw Error('failed to create public key');
    }

    const credentials = res as PublicKeyCredential;
    const attestationObject =
      credentials.response as AuthenticatorAssertionResponse;

    const result = {
      id: credentials.id,
      rawId: this.__oryWebAuthnBufferEncode(credentials.rawId),
      type: credentials.type,
      response: {
        authenticatorData: this.__oryWebAuthnBufferEncode(
          attestationObject.authenticatorData
        ),
        clientDataJSON: this.__oryWebAuthnBufferEncode(
          attestationObject.clientDataJSON
        ),
        signature: this.__oryWebAuthnBufferEncode(attestationObject.signature),
        userHandle: this.__oryWebAuthnBufferEncode(
          attestationObject.userHandle!
        ),
      },
    };

    return result;
  }

  __oryWebAuthnBufferDecode(value: any) {
    return Uint8Array.from(
      atob(value.replaceAll('-', '+').replaceAll('_', '/')),
      function (c) {
        return c.charCodeAt(0);
      }
    );
  }

  __oryWebAuthnBufferEncode(value: ArrayBuffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(value) as any))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }
}
